const wizardItems = [
  { key: 'DRAFT', label: 'Draf' },
  { key: 'SCHEDULED', label: 'Dijadwalkan' },
  { key: 'STARTED', label: 'Perjalanan' },
  { key: 'ENDED', label: 'Selesai' },
]

export const wizardStatusItems = (instance) => {
  return {
    DRAFT: { key: 'DRAFT', label: instance.$t('fleetTask.status.draft') },
    SCHEDULED: { key: 'SCHEDULED', label: instance.$t('fleetTask.status.scheduled') },
    STARTED: { key: 'STARTED', label: instance.$t('fleetTask.status.started') },
    ENDED: { key: 'ENDED', label: instance.$t('fleetTask.status.ended') },
    CANCELED: { key: 'CANCELED', label: instance.$t('fleetTask.status.canceled') },
  }
}

export default wizardItems
